<template>
    <auth-layout>
        <div class="w-full md:w-1/2 flex flex-col">
            <div class="flex flex-col justify-center md:justify-start my-auto pt-8 md:pt-0 px-8 md:px-24 lg:px-32">
                <span class="text-center text-5xl md:text-2xl lg:text-4xl xl:text-6xl font-bold" data-cy="form-header">
                    <template v-if="isEpicvaultEnabled">
                        <img
                            class="inline-block h-12 md:h-6 lg:h-8 xl:h-12"
                            :src="'/images/icon-epic-vault.png'"
                            alt="logo"
                        />
                        <span class="text-black align-bottom">Epic</span
                        ><span class="text-default-blue align-bottom">Vault</span>
                    </template>
                    <template v-else>
                        <img class="inline-block h-12 md:h-6 lg:h-8 xl:h-12" :src="'/images/icon.png'" alt="logo" />
                        <span class="text-black align-bottom">Claims</span
                        ><span class="text-default-purple align-bottom">Vault</span>
                    </template>
                </span>

                <form-forgot-password
                    :forgot_password="forgot_password"
                    :validation="validation"
                    :processing="processing"
                    :theme="getTheme"
                    @formSubmit="handleSubmit"
                    v-if="!email_sent"
                    data-cy="form_forgot_password"
                >
                </form-forgot-password>

                <span class="text-center pt-8" v-if="email_sent" data-cy="forgot_password_sent">
                    {{ $t('auth.notifications.forgot_password.email_sent') }}
                </span>

                <div class="text-center pt-12 pb-12">
                    <p>
                        <router-link :to="{ name: 'login' }" class="underline" data-cy="back_to_login">
                            {{ $t('auth.links.login') }}
                        </router-link>
                    </p>
                </div>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue';
import FormForgotPassword from '@/components/forms/auth/ForgotPassword.vue';

export default {
    components: {
        AuthLayout,
        FormForgotPassword,
    },
    data() {
        return {
            forgot_password: {
                email: '',
            },
            validation: {
                errors: {},
                message: '',
            },
            processing: false,
            email_sent: false,
        };
    },
    computed: {
        isEpicvaultEnabled() {
            return this.$store.state.system.is_epicvault_enabled;
        },
        getTheme() {
            return this.isEpicvaultEnabled ? 'default' : 'claimsvault';
        },
    },
    methods: {
        handleSubmit() {
            this.processing = true;
            this.validation = '';

            this.$http
                .post('/api/password/forgot', this.forgot_password)
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.email_sent = true;
                    } else {
                        this.validation = {
                            message: this.$t('auth.notifications.forgot_password.error'),
                        };
                    }
                })
                .catch((error) => {
                    if (
                        error.response.data.errors.email &&
                        error.response.data.errors.email[0] &&
                        error.response.data.errors.email[0] == 'CVFP02'
                    ) {
                        this.email_sent = true;
                    }
                    if (error.response.status == 422) {
                        this.validation = error.response.data;
                    } else if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVFP01' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
    },
};
</script>
